import { useState } from "react";
import { Mail, Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { getRef } from "../../lib/ref";

export const OptInCard = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      await api.post("/auth/magic", { email, opt_in: true, ref: getRef() });
      setDone(true);
    } catch {
      toast.error("Couldn't add you — check the email and try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="bg-cream py-14" aria-label="Direct booking deals" data-testid="optin-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-8">
        <div className="bg-white border-2 border-sage/30 rounded-3xl px-6 sm:px-10 py-9 text-center shadow-sm">
          {done ? (
            <div data-testid="optin-success">
              <span className="inline-flex p-3.5 rounded-full bg-sage/15 mb-3"><Check size={22} className="text-sagedeep" aria-hidden /></span>
              <h2 className="font-serif text-2xl font-semibold text-charcoal">Check your inbox</h2>
              <p className="text-soft mt-2">We sent a reusable link to <strong className="text-charcoal">{email}</strong> — it opens your welcome guide and keeps working for a year.</p>
            </div>
          ) : (
            <>
              <p className="text-xs uppercase tracking-[0.24em] text-sagedeep font-semibold mb-2">Past Guests</p>
              <h2 className="font-serif text-2xl sm:text-3xl font-semibold text-charcoal">Have you stayed with us?</h2>
              <p className="text-soft mt-2 mb-6">Get direct-booking deals — enter your email and we'll send your welcome-guide link too.</p>
              <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                <input
                  type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com" aria-label="Email for direct-booking deals"
                  className="flex-1 bg-cream border border-charcoal/15 rounded-full px-5 py-3.5 text-base outline-none focus:border-copper"
                  data-testid="optin-email-input"
                />
                <button type="submit" disabled={busy}
                  className="inline-flex items-center justify-center gap-2 bg-sagedeep text-cream font-bold rounded-full px-6 py-3.5 hover:bg-sage transition-colors disabled:opacity-50"
                  data-testid="optin-submit-button">
                  <Mail size={16} aria-hidden /> {busy ? "Sending…" : "Send my link"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </section>
  );
};
